// ErrorBoundary.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, Col, Row } from 'antd';
import IntlMessage from '../../../components/util-components/IntlMessage';
import { LeftSquareOutlined } from '@ant-design/icons';
import { handleErrorApi } from '../../../serviceHandler/SlackErrorHandler';

const ErrorBoundary = ({ children }) => {
    const [hasError, setHasError] = useState(false);
    const [errorInfo, setErrorInfo] = useState(null);
    const navigate = useNavigate();

    const handleError = (error, type) => {
        if (hasError) return;
        console.error('Error caught:', error);
        handleErrorApi(error, type);
        setErrorInfo({ error, type });
        setHasError(true);
    };

    useEffect(() => {
        const handleGlobalError = (event) => {
            handleError(event.error || event, 'error');
        };

        const handleUnhandledRejection = (event) => {
            handleError(event.reason || event, 'unhandledrejection');
        };

        window.addEventListener('error', handleGlobalError);
        window.addEventListener('unhandledrejection', handleUnhandledRejection);

        return () => {
            window.removeEventListener('error', handleGlobalError);
            window.removeEventListener('unhandledrejection', handleUnhandledRejection);
        };
        // eslint-disable-next-line
    }, [navigate, hasError]);

    if (hasError) {
        return <Error errorInfo={errorInfo} />;
    }

    return <>{children}</>;
};

const Error = ({ errorInfo }) => {
    const theme = useSelector((state) => state.theme.currentTheme);

    return (
        <div className={`h-100 ${theme === 'light' ? 'bg-white' : ''}`}>
            <div>
                <br /><br />
            </div>
            <div className="container">
                <Row align="middle">
                    <Col xs={24} sm={24} md={8}>
                        <h1 className="font-weight-bold mb-4 display-4">
                            <IntlMessage id={'general.error.pageNotFound'} />
                        </h1>
                        <p className="font-size-md mb-4">
                            <IntlMessage id={'general.error.text'} />
                        </p>

                        {/* Prikaz detalja greške za debugging */}
                        {errorInfo && (
                            <pre className="text-danger" style={{ whiteSpace: 'pre-wrap' }}>
                                {JSON.stringify(errorInfo, null, 2)}
                            </pre>
                        )}

                        <Link to="/app">
                            <Button
                                type="none"
                                className="our-button-color-cancel"
                                style={{ marginLeft: '10px' }}
                                onClick={() => window.location.href = '/app'}
                            >
                                <LeftSquareOutlined /> <IntlMessage id={'form.cancel'} />
                            </Button>
                        </Link>
                    </Col>
                    <Col xs={24} sm={24} md={{ span: 14, offset: 2 }}>
                        <img className="img-fluid mt-md-0 mt-4" src="/img/others/img-20.png" alt="Error Illustration" />
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default ErrorBoundary;
